import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardTopAlarmsContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardTopAlarmsProvider = ({ children }) => {

  const [topAlarms, setTopAlarms] = useState(null);
  const [topAlarmsMonitoredIndividualsAndUnits, setTopAlarmsMonitoredIndividualsAndUnits] = useState(null);
  const [topAlarmsTimeRange, setTopAlarmsTimeRange] = useState(timeRanges[0]);
  const [topAlarmsLoading, setTopAlarmsLoading] = useState(null);
  const [topAlarmsError, setTopAlarmsError] = useState(null);


  const setTheTopAlarms = (topAlarms) => {
    if (logComponent('CardTopAlarmsContext')) { console.debug('CardTopAlarmsContext setTheTopAlarms'); }
    let newTopAlarms = topAlarms ? [ ...topAlarms ] : null;
    setTopAlarms(newTopAlarms);
  }
  
  const setTheTopAlarmsMonitoredIndividualsAndUnits = (theTopAlarmsMonitoredIndividualsAndUnits) => {
    if (logComponent('CardTopAlarmsContext')) { console.debug('CardTopAlarmsContext setTheTopAlarmsMonitoredIndividualsAndUnits'); }
    let newTopAlarmsMonitoredIndividualsAndUnits = theTopAlarmsMonitoredIndividualsAndUnits ? [...theTopAlarmsMonitoredIndividualsAndUnits ] : null;
    setTopAlarmsMonitoredIndividualsAndUnits(newTopAlarmsMonitoredIndividualsAndUnits);
  }

  const setTheTopAlarmsTimeRange = (timeRange) => {
    if (logComponent('CardTopAlarmsContext')) { console.debug('CardTopAlarmsContext setTheTopAlarmsTimeRange'); }
    let newTimeRange = timeRange;
    setTopAlarmsTimeRange(newTimeRange);
  }

  const setTheTopAlarmsLoading = (topAlarmsLoading) => {
    if (logComponent('CardTopAlarmsContext')) { console.debug('CardTopAlarmsContext setTheTopAlarmsLoading'); }
    let newTopAlarmsLoading = topAlarmsLoading;
    setTopAlarmsLoading(newTopAlarmsLoading);
  }

  const setTheTopAlarmsError = (topAlarmsError) => {
    if (logComponent('CardTopAlarmsContext')) { console.debug('CardTopAlarmsContext setTheTopAlarmsError'); }
    let newTopAlarmsError = topAlarmsError;
    setTopAlarmsError(newTopAlarmsError);
  }



  const cardState = useMemo(() => ({
    timeRanges,
    topAlarms,
    topAlarmsMonitoredIndividualsAndUnits,
    topAlarmsTimeRange,
    topAlarmsLoading,
    topAlarmsError,
    setTopAlarms: setTheTopAlarms,
    setTopAlarmsMonitoredIndividualsAndUnits: setTheTopAlarmsMonitoredIndividualsAndUnits,
    setTopAlarmsTimeRange: setTheTopAlarmsTimeRange,
    setTopAlarmsLoading: setTheTopAlarmsLoading,
    setTopAlarmsError: setTheTopAlarmsError
  }), [
    timeRanges,
    topAlarms,
    topAlarmsMonitoredIndividualsAndUnits,
    topAlarmsTimeRange,
    topAlarmsLoading,
    topAlarmsError
]);

  return (
    <CardTopAlarmsContext.Provider value={ cardState }>
      {children}
    </CardTopAlarmsContext.Provider>
  );
}

// export provider and context
export { CardTopAlarmsContext, CardTopAlarmsProvider };